module.exports = __webpack_public_path__ + "media/customizations/lmws/logo-new-a7dbd2a3c1892c5e5630872994ced2b7.png";